// @ts-nocheck
/* Store Custom File */

import { EagerLoadingLogoProvider } from "@insite/client-framework/Common/EagerLoadingLogo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import dismissRfqUpdates from "@insite/client-framework/Store/Context/Handlers/DismissRfqUpdates";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { setCookie } from "@insite/mobius/utilities/cookies";
import Cookies from "js-cookie";

/* Store Custom Code - Start */
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
/* Store Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    siteName: state.context.website.name,
    session: getSession(state),
    myAccountPageUrl: getPageLinkByPageType(state, "MyAccountPage")?.url,
});

const mapDispatchToProps = {
    dismissRfqUpdates,
};

type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext &
    HasHistory;

export interface HeaderStyles {
    page?: MobiusPageProps;
    container?: InjectableCss;
    skipToContent?: SkipNavStyles;
    websiteName?: InjectableCss;
    // Store Custom Code
    navigationWrapper?: InjectableCss;
}

export const headerStyles: HeaderStyles = {
    page: {
        // Store Removed - fullWidth
        /* Store Custom Code - Start */
        css: css`
            background-color: ${getColor("primary.dark")};
        `,
        /* Store Custom Code - End */
    },
    container: {
        css: css`
            /* Store Custom Code - Start */
            ${siteWidthStyles()}
            display: flex;
            justify-content: center;
            /* Store Custom Code - End */
        `,
    },
    websiteName: {
        css: css`
            @media print {
                display: block;
            }
            font-size: 12px;
            padding-left: 15px;
            display: none;
        `,
    },
};

const styles = headerStyles;

const Header = ({ id, siteName, session, toaster, history, myAccountPageUrl, dismissRfqUpdates }: Props) => {
    const viewMyDashboardClickHandler = () => {
        if (myAccountPageUrl) {
            history.push(myAccountPageUrl);
        }
    };

    useEffect(() => {
        if (session.hasRfqUpdates && myAccountPageUrl) {
            toaster.addToast({
                body: (
                    <>
                        <Typography>{translate("You have new quote information.")}</Typography>
                        <Link onClick={viewMyDashboardClickHandler}>{translate("View My Dashboard")}</Link>
                    </>
                ),
                messageType: "info",
                timeoutLength: 1000 * 60 * 60 * 24 * 365,
                onClose: () => {
                    dismissRfqUpdates();
                },
            });
        }
    }, [myAccountPageUrl]);

    //LSE-17 
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const newUtmParams = {
          utm_campaign: params.get("utm_campaign") || "",
          utm_medium: params.get("utm_medium") || "",
          utm_source: params.get("utm_source") || "",
        };
        // const ONE_MINUTE_IN_DAYS = 1 / 1440;  // 1 minute = 1/1440 days
        const TWO_HOUR_IN_DAYS = 2 / 24;
        Cookies.set("utmParams", JSON.stringify(newUtmParams), { expires: TWO_HOUR_IN_DAYS });
      }, []);

     // cookie clear on tab close   
      useEffect(() => {
        const handleUnload = () => {
        Cookies.remove("utmParams");
        };
        window.addEventListener('unload', handleUnload);
        return () => {
          window.removeEventListener('unload', handleUnload);
        };
      }, []);

    const afterHeader = React.createRef<HTMLSpanElement>();
    
    return (
        <>
            {siteName && <Typography {...styles.websiteName}>{siteName}</Typography>}
            <Page as="header" isHeader={true} {...styles.page}>
                <SkipNav
                    extendedStyles={styles.skipToContent}
                    text={translate("Skip to main content")}
                    destination={afterHeader}
                />
                <EagerLoadingLogoProvider value={true}>
                    <Zone contentId={id} zoneName="SecondaryNavigation" /> {/* Store Removed - fixed */}
                    <StyledWrapper {...styles.navigationWrapper /* Store Custom Code */}>
                        <StyledWrapper {...styles.container}>
                            <Zone contentId={id} zoneName="MainNavigation" /> {/* Store Removed - fixed */}
                            {/* Store Removed - Cart */}
                        </StyledWrapper>
                    </StyledWrapper>
                    <Zone contentId={id} zoneName="Breadcrumb" />
                </EagerLoadingLogoProvider>
                <span ref={afterHeader} tabIndex={-1} />
            </Page>
        </>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(Header))),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export const HeaderContext = "HeaderContext";

export default pageModule;
